import Vue from 'vue';
import {
	sendWebsocket,
	closeWebsocket
} from './socket.js'

let SessionId = '',
	WorkKey = '',isDecrypt=false//是否正在解密

let $message
/**
 * 解密
 * @param {string} KeyId  密钥
 * @param {string} Data 密文
 * @param {string} fileId 文件id用于转加密秘钥的
 **/
function decrypt(KeyId, Data,fileId) {
	if(isDecrypt==true)return
	isDecrypt=true
	$message&&$message.close()
	showLoding('量子解密中...')
	return new Promise(async (resolve, reject) => {
		//先判断SessionId是否获取到，没有先获取在解密
		if (SessionId) {
			//获取转加密秘钥secretKey
			let secretKey = await getEncryptionKey(fileId)
			//更新工作密钥(导入加密秘钥)
			let kekdata= await updateWorkKey(secretKey)
			if(kekdata.code==200){
				//解密
				startDecrypt(Data).then(base=>{
					resolve(base)
				}).catch(err=>{
					reject(err)
				})
			}
		} else {
			// 获取sessionId 
			let res = await getSessionId()
			if (res.code == 200) {
				//获取转加密秘钥secretKey
				let secretKey = await getEncryptionKey(fileId)
				//更新工作密钥(导入加密秘钥)
				let kekdata= await updateWorkKey(secretKey)
				if(kekdata.code==200){
					//解密
					startDecrypt(Data).then(base=>{
						resolve(base)
					}).catch(err=>{
						reject(err)
					})
				}
			}
		}
	})
}
//1. 获取sessionId 后面的服务调用都需要这个 sessionId
function getSessionId() {
	//请求格式
	//包长度|设备类型|请求码|时间|前端ID|应用ID|参数列表|序号|
	let cmd = "48|02|101|20211208110456|MSGID0013456|APPID000||1|"
	return new Promise((reslove, reject) => {
		sendWebsocket(cmd, (res) => {
			//返回格式
			//包长度|设备类型|请求码|时间|前端ID|应用ID|应答码|应答说明|返回内容|序号|是否有后续包|
			if (res) {
				SessionId = getInfo(res, '|', 7)
				if (SessionId) {
					console.log('1.获取sessionId成功' + SessionId);
					reslove({
						code: 200,
						msg: '获取sessionId成功'
					})
				} else {
					notify('获取sessionId失败', getInfo(res, '|', 6), 'warning')
					reject({
						code: -1,
						msg: '获取sessionId失败'
					})
				}
			}
		}, err => {
			notify('获取sessionId失败', getInfo(res, '|', 6), 'warning')
			reject({
				code: -1,
				msg: err
			})
		})
	})


}
//获取转加密秘钥（通过useb-key的序列号，和文件id进行转加密）
async function getEncryptionKey(fileId){
	//获取序列号tKeyIndex
	let deviceInfo= await getDeviceInfo()
	console.log('deviceInfo',deviceInfo);
	if(deviceInfo.code!=200){
		notify('获取设备序列号失败', '', 'warning')
		return
	}
	return new Promise((reslove, reject) => {
		//获取转加密秘钥（通过useb-key的序列号进行转加密）
		doGet('', {
			fileId: fileId,
			tKeyIndex: deviceInfo.data.value
		}).then(res=>{
			reslove(res.msg)
		}).catch(err=>{
			reject(err)
		})
	})
}

//2.更新工作密钥(导入加密秘钥)
/**
 * 从后台获取的密钥字段secretKey共240字节，前224字节为密钥密文，后16字节为密钥校验值。
 * @param {string} secretKey 密钥
 **/
async function updateWorkKey(secretKey) {
	// 密钥密文
	let ciphertext = secretKey.slice(0, 224)
	// 密钥校验值
	let key = secretKey.slice(224, 240)
	let length = `|01|203|20220326110456|MSGID0013456|APPID000|${SessionId},${ciphertext},${key}|1|`.length
	//包长度|设备类型|请求码|时间|前端ID|应用ID|参数列表|序号|
	let cmd = `${length}|01|203|20220326110456|MSGID0013456|APPID000|${SessionId},${ciphertext},${key}|1|`
	console.log('导入加密秘钥',cmd);
	return new Promise((reslove, reject) => {
		sendWebsocket(cmd, (res) => {
			console.log(res);
			//返回格式
			//包长度|设备类型|请求码|时间           |前端ID      |应用ID  |应答码|应答说明|返回内容|序号|是否有后续包|
			// 00058| 01   |203   |20220326110456|MSGID0013456|APPID000|0000|OK      |       |1   |0|
			if (res) {
				WorkKey = getInfo(res, '|', 6)
				if (WorkKey == 'OK') {
					console.log('2.更新工作密钥成功' + WorkKey);
					reslove({
						code: 200,
						msg: '更新工作密钥成功'
					})
					// updateWorkKey()
				} else {
					notify('更新工作密钥失败', getInfo(res, '|', 6), 'warning')
					reject({
						code: -1,
						msg: '更新工作密钥失败' + getInfo(res, '|', 6)
					})
				}
			}
		}, err => {
			notify('更新工作密钥失败', getInfo(res, '|', 7), 'warning')
			reject({
				code: -1,
				msg: err
			})
		})
	})
}
// 开始解密
function startDecrypt(ciphertext) {
	let length = `|01|303|20220326094348|MSGID0013456|APPID000|${SessionId},${ciphertext},xxx|1|`.length
	// 包长度|设备类型|请求码|时间|前端ID|应用ID|参数列表|序号|
	// 4877227|01|303|20220316094348|MSGID0013456|APPID000|SESSIONID_861CFC36B5A293F8,ADfQdrKyTb1/RiOQv1idA
	let cmd = `${length}|01|303|20220326094348|MSGID0013456|APPID000|${SessionId},${ciphertext},xxx|1|`
	console.log('开始解密', cmd.slice(0, 200) + '...');
	return new Promise((reslove, reject) => {
		sendWebsocket(cmd, (res) => {
			// 返回格式
			// 包长度|设备类型|请求码|时间|前端ID|应用ID|应答码|应答说明|返回内容|序号|是否有后续包|
			if (res) {
				let base64 = getInfo(res, '|',7)
				if(base64){
					$message.close()
					Vue.prototype.$message.success('解密成功')
					isDecrypt=false
					console.log('3.解密成功',base64.slice(0, 100));
					reslove({code:200,msg:'解密成功',data:'data:image/jpeg;base64,'+base64})
				}else{
					notify('解密失败', getInfo(res, '|',7), 'warning')
					reject({code:-1,msg:'解密失败'+getInfo(res, '|',7)})
				}
			}
		}, err => {
			notify('解密失败', getInfo(res, '|',7), 'warning')
			reject({
				code: -1,
				msg: err
			})
		})
	})
}

//获取设备信息如设备ID，厂商，名称，设备类型等信息
function getDeviceInfo(){
	return new Promise((reslove,reject)=>{
		// 00074|02|102|20191202110456|MSGID0013456|APPID000|SESSIONID_D1EBD9CBC46C4B88|1|
		let cmd = `00080|02|102|20220328143902|MSGID0013456|APPID000|${SessionId}|1|`
		sendWebsocket(cmd, (res) => {
			//返回格式
			//包长度|设备类型|请求码|时间|前端ID|应用ID|应答码|应答说明|返回内容|序号|是否有后续包|
			let info = getInfo(res, '|', 7)
			if (res&&info) {
				//这是获取设备信息值
				let arr=info.split(',').map(item=>{
					let iarr=item.split('=')
					return {
						key:iarr[0],
						value:iarr[1]
					}
				})
				reslove({
					code: 200,
					data:arr[1],
					msg: '获取设备信息成功'
				})
			}else{
				notify('获取设备信息失败', getInfo(res, '|',7), 'warning')
			}
		}, err => {
			console.log(err);
			notify('获取设备信息失败', getInfo(res, '|',7), 'warning')
		})
	})
}


/**
 * 获取一个字符串值在指定字符串第n次出现的位置到第n+1位置的中间内容
 * @param {string} str  要获取的原始内容
 * @param {string} cha 要找的字符串
 * @param {string} num cha第几次出现的位置
 **/
function getInfo(str, cha, num) {
	let index = find(str, cha, num)
	let index2 = find(str, cha, num + 1)
	let strin = str.slice(index + 1, index2)
	return strin
}

function find(str, cha, num) {
	var x = str.indexOf(cha);
	for (var i = 0; i < num; i++) {
		x = str.indexOf(cha, x + 1);
	}
	return x;
}

function notify(title, message, type) {
	Vue.prototype.$notify({
		title,
		message,
		type
	});
	$message&&$message.close()
	isDecrypt=false
}
function showLoding(title){
	$message=Vue.prototype.$message({
		message: title,
		iconClass: 'el-icon-loading',
		duration:0
	});
}

//转加密接口需要海泰usbkey的序列号
function doGet(url, req, successCallback, errorCallback) {
	let host = window.location.href.match(/((.*?)\/\/(.*?))\//)[1]
	let service_url = process.env.NODE_ENV === 'development' ? '/apis' : (host + '/stamper/apis')
	return new Promise((resolt, rejcet) => {
		Vue.http.get(service_url+'/gkQss/transCryption1', {
			params: req
		}, {
			emulateJSON: true, //允许跨越
		}).then(function(response) {
			// 响应成功回调
			successCallback && successCallback(response.data);
			resolt(response.data)
		}, function(error) {
			// 响应错误回调
			errorCallback && errorCallback(error)
			rejcet(error)
		});
	})
}

export default {
	decrypt,
	getSessionId
}



// WEBPACK FOOTER //
// ./static/js/function/gkQSS.js